import { render, staticRenderFns } from "./VotingRightsReport.vue?vue&type=template&id=5239a622"
import script from "./VotingRightsReport.vue?vue&type=script&lang=js"
export * from "./VotingRightsReport.vue?vue&type=script&lang=js"
import style0 from "./VotingRightsReport.vue?vue&type=style&index=0&id=5239a622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports